import { localizedLegalPath } from "@/shared/legal/localized-legal-path.mjs";
import { useMemo } from "react";
import { Link } from "react-router-dom";
import { publicWebCopyForLang } from "@/shared/i18n/public-web-copy";
import { BrandMark } from "@/shared/brand/BrandMark";

type MarketingFooterProps = {
  lang: string;
};

export function MarketingFooter({ lang }: MarketingFooterProps) {
  const copy = useMemo(() => publicWebCopyForLang(lang), [lang]);
  return (
    <footer className="mkt-footer">
      <div className="mkt-footer-grid">
        <div>
          <p className="mkt-footer-brand">
            <BrandMark />
            Today&apos;s Brief
          </p>
          <p className="mkt-footer-tagline">{copy("marketing.footer.tagline")}</p>
        </div>
        <nav aria-label={copy("marketing.footer.productNav")}>
          <p className="mkt-footer-heading">{copy("marketing.footer.product")}</p>
          <Link to="/pricing">{copy("marketing.layout.pricing")}</Link>
          <Link to="/faq">{copy("marketing.layout.faq")}</Link>
          <Link to="/app/brief">{copy("marketing.footer.openBrief")}</Link>
        </nav>
        <nav aria-label={copy("marketing.footer.accountNav")}>
          <p className="mkt-footer-heading">{copy("marketing.footer.account")}</p>
          <Link to="/auth/sign-in">{copy("marketing.layout.signIn")}</Link>
          <Link to="/auth/sign-up">{copy("marketing.footer.signUp")}</Link>
          <a href={localizedLegalPath("/support.html", lang)}>{copy("marketing.footer.support")}</a>
        </nav>
        <nav aria-label={copy("marketing.footer.legalNav")}>
          <p className="mkt-footer-heading">{copy("marketing.footer.legal")}</p>
          <a href={localizedLegalPath("/privacy.html", lang)}>{copy("marketing.footer.privacy")}</a>
          <a href={localizedLegalPath("/terms.html", lang)}>{copy("marketing.footer.terms")}</a>
          <a href={localizedLegalPath("/editorial-source-policy.html", lang)}>
            {copy("marketing.footer.editorial")}
          </a>
          <a href={localizedLegalPath("/financial-disclaimer.html", lang)}>
            {copy("marketing.footer.financial")}
          </a>
          <a href={localizedLegalPath("/account-deletion.html", lang)}>
            {copy("marketing.footer.deletion")}
          </a>
        </nav>
      </div>
      <p className="mkt-footer-copy">
        {copy("marketing.footer.copyright", { year: new Date().getFullYear() })}
      </p>
    </footer>
  );
}
